import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

/**
 * Retorna os cadastros por equipe
 *
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 *
 * @returns {Array}
 */
export async function getDadosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await api.get(
      '/app/cadastros-sem-cpf/equipe/' + cod_ibge + '/' + nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Retorna os cadastros por microárea
 *
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 * @param {String} micro_area - Microárea
 *
 * @returns {Array}
 */
export async function getDadosPorMicroArea(cod_ibge, nu_ine, micro_area) {
  try {
    const { data } = await api.get(
      '/app/cadastros-sem-cpf/' +
        cod_ibge +
        '/equipe/' +
        nu_ine +
        '/microarea/' +
        micro_area
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Gera o relatório em PDF.
 *
 * @param {Array} cadastros
 * @param {Object} selectEquipe
 * @param {String} microArea
 */
export function generatePdf(cadastros, selectEquipe, microArea) {
  const titlePdf = 'Cadastros sem CPF'
  const titlePdfSave = utils.methods.titlePdf(titlePdf, selectEquipe.no_equipe)
  const descriptionPdf = 'Pessoas com cadastro individual na microárea sem CPF'
  const headersPdf = [
    'NOME',
    'DATA DE NASCIMENTO',
    'MÃE',
    'MA',
    'CADASTRADO POR',
  ]

  const dataPdf = cadastros.map((item) => {
    const documentos = []
    if (item.nu_cpf) documentos.push(`CPF ${item.nu_cpf}`)
    if (item.nu_cns) documentos.push(`CNS ${item.nu_cns}`)

    return {
      no_cidadao: item.no_cidadao,
      dt_nascimento: utils.methods.formatDate(item.dt_nascimento),
      no_mae: item.no_mae,
      micro_area: item.micro_area,
      cadastrado_por: item.no_profissional,
      // documento: documentos.join('\n'),
    }
  })

  const doc = new jsPDF(utils.methods.encryptionPdf())
  const table = utils.methods.createTablePdf(dataPdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64Brasao) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )

      const equipeInfo = [
        { label: 'Equipe', value: selectEquipe.no_equipe },
        { label: 'CNES', value: selectEquipe.nu_cnes },
        { label: 'INE', value: selectEquipe.ine_esf_eap },
        { label: 'Microárea', value: microArea },
      ]

      verticalPosition = utils.methods.bodyPdf(
        doc,
        equipeInfo,
        verticalPosition
      )

      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
  'Cadastrado por': 'no_profissional',
}
